import { crudRequest } from '@/services/api';

const state = {}
for (let dsIndex = 0; dsIndex < 2; dsIndex++) {
  state[`send${dsIndex}`] = {}
}

export default {
  namespace: 'send',
  state: { ...state },

  effects: {
    *send({ payload: { data, dsIndex } }, { call, put, select }) {
      yield put({ type: 'updateState', payload: { [`send${dsIndex}`]: data[0].result } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}